/*
 * hy.frontend.core
 *
 * NOTE: this file is not subject to copyright transfer
 * UWAGA: plik nie objęty przekazaniem praw autorskich
 * © 2016 Hycom S.A.
 *
 */





define(function() {

    return {
        framework: {
            ready: 'framework.ready'
        },
        modules: {
            init: 'modules.init',
            ready: 'modules.ready',

            modal: {
                open: 'modules.modal.open',
                close: 'modules.modal.close',
                opened: 'modules.modal.opened',
                closed: 'modules.modal.closed',
                willClosed: 'modules.modal.willClosed',
                isOpened: 'modules.modal.isOpened',
                changeSize: 'modules.modal.changeSize',
                ajaxModulesLoaded: 'modules.modal.ajaxModulesLoaded'
            },
            switcher: {
                onchange: 'modules.switcher.onchange',
                choose: 'modules.switcher.choose'
            },
            expander: {
                complete: 'modules.expander.complete', //left 'complete' (not 'completed') for backwards compatibility
                triggered: 'modules.expander.triggered', //private
                expanded: 'modules.expander.expanded',
                collapsed: 'modules.expander.collapsed',
                animation: {
                    started: 'modules.expander.animation.started',  //private
                    ended: 'modules.expander.animation.ended'  //private
                },
                toggle: 'modules.expander.toggle',
                open: 'modules.expander.open',
                close: 'modules.expander.close',
                next: 'modules.expander.next',
                prev: 'modules.expander.prev',
                openall: 'modules.expander.openall',
                closeall: 'modules.expander.closeall',
                loadHash: 'modules.expander.loadHash',
                reinit: 'modules.expander.reinit'
            },
            sticker: {
                initialized: 'modules.sticker.initialized'
            },
            clickAndHover: {
                open: 'modules.clickAndHover.open',
                opened: 'modules.clickAndHover.opened',
                close: 'modules.clickAndHover.close',
                closed: 'modules.clickAndHover.closed'
            },
            basket: {
                content: {
                    update: 'modules.basket.content.update',
                    updated: 'modules.basket.content.updated'
                },
                counter: {
                    update: 'modules.basket.counter.update',
                    updated: 'modules.basket.counter.updated'
                }
            },
            header: {
                fixed: 'modules.header.fixed',
                closeDesktopMenu: 'modules.header.closeDesktopMenu',
                recalculateMenu: 'modules.header.recalculateMenu'
            },
            masterChecker: {
                master: {
                    check: 'modules.masterChecker.master.check',
                    checked: 'modules.masterChecker.master.checked',
                    uncheck: 'modules.masterChecker.master.uncheck',
                    unchecked: 'modules.masterChecker.master.unchecked'
                },
                slave: {
                    checked: 'modules.masterChecker.slave.checked',
                    unchecked: 'modules.masterChecker.slave.unchecked'
                }
            },
            layoutFixer: {
                recalculate: 'modules.layoutFixer.recalculate',
                recalculated: 'modules.layoutFixes.recalculated'
            },
            loader: {
                show: 'modules.loader.show',
                isVisible: 'modules.loader.isVisible',
                isHiden: 'modules.loader.isHiden',
                hide: 'modules.loader.hide'
            },
            slidindlabels: {
                reset: 'modules.slidindlabels.reset'
            },
            floatinglabels: {
                reset: 'modules.floatinglabels.reset',
                checkvalue: 'modules.floatinglabels.checkvalue'
            },
            toggler: {
                changed: 'modules.toggler.changed',
                show: 'modules.toggler.show',
                hide: 'modules.toggler.hide'
            }
        }
    };
});
